import moment from 'moment';

export default function DateTimeDirective() {
  return {
    template: require('./date-time.component.html'),
    transclude: true,
    restrict: 'AE',
    scope: {},
    bindToController: {
      date: '=ngModel',
      form: '=',
      maxDate: '=',
      minDate: '=',
      hasError: '=',
      type: '=',
      onSave: '=',
      onChange: '=',
    },
    controllerAs: 'vm',
    controller: DateTimeController,
  };

  function DateTimeController($scope, $filter, TimezoneService) {
    'ngInject';
    let vm = this;
    vm.dateOptions = {
      'year-format': "'yy'",
      'starting-day': 1,
    };
    vm.$onInit = () => {
      init();
    };
    $scope.$watch(
      function () {
        return vm.date;
      },
      function () {
        setFormValidity();
      },
    );
    $scope.$watch(
      function () {
        return vm.minDate;
      },
      function () {
        setFormValidity();
      },
    );

    $scope.$watch(
      function () {
        return vm.maxDate;
      },
      function () {
        setFormValidity();
      },
    );

    function init() {
      vm.showTime = vm.type === 'Datetime';
      vm.dateChanged = dateChanged;
      vm.onSave.invoke = onSave;

      if (!vm.date) {
        vm.date = moment().toDate();

        if (vm.maxDate) {
          setTime(vm.date, -24, 0, 0, 0);
        } else if (vm.minDate) {
          setTime(vm.date, 24, 0, 0, 0);
        }
      } else {
        vm.date = moment(vm.date).toDate();
      }
      vm.date = TimezoneService.convertToSameTimeInUserTimeZone(vm.date).toDate();
    }

    function onSave() {
      if (vm.type === 'date') {
        vm.date = vm.date ? $filter('date')(vm.range.min, 'yyyy-MM-dd') : undefined;
      } else if (vm.type === 'dateTime') {
        //TODO: this needs looking into. should be done with moment
        vm.date = vm.date
          ? new Date(
              new Date(vm.range.min).getTime() -
                new Date(vm.range.min).getTimezoneOffset() * 60000 -
                TimezoneService.getUserTimezoneOffset(new Date(vm.range.min)) * 60000,
            )
          : undefined;
      }
    }

    function setFormValidity() {
      vm.dateTimeForm.date.$setValidity('min', !vm.minDate || vm.minDate < vm.date);
      vm.dateTimeForm.date.$setValidity('max', !vm.maxDate || vm.maxDate > vm.date);
    }

    function dateChanged() {
      if (!vm.showTime) {
        setTime(vm.date, 0, 0, 0, 0);
      }
      vm.onChange();
    }

    function setTime(date, hours, minutes, seconds, milliseconds) {
      if (!date) return;
      date.setHours(hours);
      date.setMinutes(minutes);
      date.setSeconds(seconds);
      date.setMilliseconds(milliseconds);
    }
  }
}
